<script lang="ts">
  /**
   * A sentence that belongs to the `Group` just above it ("Your name is shown
   * to the people you play with"): small, quiet, tucked up under the block.
   * TwinTen's settings note. `tone="error"` is the same place for what went
   * wrong with that group, announced at once (`role="alert"`).
   *
   * (TwinTen drew it in its decoration grey; the shell reserves `--ui-muted`
   * for non-text, so it is `--ui-ink-2`.)
   *
   * Test id: `testid`. No default.
   */
  import type { Snippet } from 'svelte';

  interface Props {
    readonly children: Snippet;
    readonly tone?: 'muted' | 'error';
    readonly testid?: string | undefined;
  }
  const { children, tone = 'muted', testid }: Props = $props();
</script>

<p
  class="ui-group-note"
  class:ui-group-note--error={tone === 'error'}
  role={tone === 'error' ? 'alert' : undefined}
  data-testid={testid}
>
  {@render children()}
</p>

<style>
  .ui-group-note {
    margin: -0.4rem 0.25rem 0.9rem;
    font: var(--ui-text-caption);
    font-weight: 400;
    line-height: 1.4;
    color: var(--ui-ink-2);
  }

  .ui-group-note--error {
    font: var(--ui-text-label);
    font-weight: 400;
    line-height: 1.4;
    color: var(--ui-danger);
  }
</style>
